export default __webpack_public_path__ + "static/media/grow-my-money-icon.d6bfa787.svg";